import React, { useMemo } from "react";
import style from "./Footer.module.scss";
import { ClientType } from "../../pages/Bridge";
import useDeviceType from "../../Utils/useDeviceType";

export default function Footer() {
    const isInside = useMemo(() => {
        return localStorage.getItem("clientType") === ClientType.Dufe;
    }, []);

    const { isPC } = useDeviceType();

    if (isInside || !isPC) return null;

    return (
        <div className={style.root}>
            <p>Copyright©东北财经大学 All Rights Reserved.</p>
            <p>技术支持: 东北财经大学网络教育学院</p>
        </div>
    );
}
